import { Box, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useTheme } from "@emotion/react";
import { useUrlParams } from "hooks/useUrlParams";

import {
  getGuidelinesUrl,
  termsOfServiceUrls,
  privacyPolicyUrls,
} from "constants/links";

const Footer = () => {
  const { soulId, lng, work, contentWork } = useUrlParams();
  const { t } = useTranslation(["common"]);
  const navigate = useNavigate();
  const theme = useTheme();

  // ルートに ?lng=xx をつける
  const withLng = (path) => {
    const hasQuery = path.includes("?");
    return lng ? `${path}${hasQuery ? "&" : "?"}lng=${lng}` : path;
  };

  const links = [
    {
      label: `${t("common:Footer.my_page")}`,
      path: `/${work}/mypage?soul_id=${soulId}`,
    },
    {
      label: `${t("common:Footer.quests")}`,
      path: `/${work}/quests?soul_id=${soulId}`,
    },
    {
      label: `${t("common:Footer.purchase_ticket")}`,
      path: `/${work}/tickets?soul_id=${soulId}`,
    },
    {
      label: `${t("common:Footer.how_to_play")}`,
      path: `/${work}/how-to-use?soul_id=${soulId}`,
    },
    {
      label: `${t("common:Footer.news")}`,
      path: `/${work}/news?soul_id=${soulId}`,
    },
    {
      label: `${t("common:Footer.contact")}`,
      url: "https://line.me/R/ti/p/@314jdaww",
    },
    {
      label: `${t("common:Footer.guidelines")}`,
      url: getGuidelinesUrl(contentWork, lng),
    },
    {
      label: `${t("common:Footer.terms_of_service")}`,
      url: termsOfServiceUrls[lng],
    },
    {
      label: `${t("common:Footer.privacy_policy")}`,
      url: privacyPolicyUrls[lng],
    },
  ];

  const commonStyles = {
    cursor: "pointer",
    transition: "color 0.2s, transform 0.2s",
    "&:hover": { color: "lightgray", transform: "scale(1.05)" },
    "&:active": { color: "gray", transform: "scale(0.95)" },
  };

  return (
    <Box
      sx={{
        backgroundColor: "transparent",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 2,
        pt: 5,
        pb: 12,
        // color: theme.Footer.color,
      }}
    >
      {links.map((link, index) => (
        <Typography
          key={index}
          // fontFamily={theme.Footer.fontFamily}
          // fontSize="16px"
          // fontWeight="bold"
          sx={{
            ...commonStyles,
            ...theme.components.footer,
          }}
          onClick={
            link.path
              ? () => navigate(withLng(link.path))
              : link.url
              ? () => {
                  window.open(link.url, "_blank");
                }
              : undefined
          }
        >
          {link.label}
        </Typography>
      ))}
    </Box>
  );
};

export default Footer;
